export const API_BASE_URL = "https://api.cemiteriosaogoncalo.com.br";
//export const API_BASE_URL = "http://localhost:5000";
export const API_UPLOAD_DIRECTORY = API_BASE_URL + "/api/upload";
export const API_UPLOAD_FALECIDOS = API_UPLOAD_DIRECTORY + "/falecidos";
export const API_UPLOAD_JAZIGOS = API_UPLOAD_DIRECTORY + "/jazigo_image";
export const API_UPLOAD_DOCUMENTS = API_UPLOAD_DIRECTORY + "/documento_falecido";
export const API_DOCUMENTS_FOLDER = API_BASE_URL + "/uploads/documentos";
export const API_JAZIGOS_FOLDER = API_BASE_URL + "/uploads/jazigos";
export const API_FALECIDOS_FOLDER = API_BASE_URL + "/uploads/falecidos";
export const API_VIDEO_FOLDER = API_BASE_URL + "/uploads/videos"